/**
 * Eigene Stammdaten von ABSINA - 1:1-Portierung aus `index.html` (Stand 2026-08-08).
 *
 * Beide Konstanten beschreiben ABSINA selbst und nicht einen Geschaeftsvorgang: wohin die Ware
 * geliefert wird (die eigenen Lagerorte) und unter welcher Anschrift ABSINA als Rechnungsempfaenger
 * auftritt. Sie aendern sich gemeinsam, wenn sich am Unternehmen etwas aendert - deshalb stehen sie
 * hier zusammen und nicht bei den Zahlungsmodalitaeten (`payments.ts`), die Konditionen der
 * Lieferanten beschreiben.
 *
 * Werte woertlich uebernommen, ergaenzt wurden ausschliesslich Typen.
 */

/**
 * Auswahl der Lagerorte einer Bestellung (index.html:4064). Der erste Eintrag enthaelt ein
 * Mittelpunkt-Trennzeichen (`·`, U+00B7), nicht einen Bindestrich - woertlich uebernommen.
 */
export const DEFAULT_WAREHOUSES: readonly string[] = [
  "Buchen · ABSINA Hauptlager",
  "Amazon FBA",
  "Direktlieferung",
];

export interface BillingAddress {
  company: string;
  companyAddition: string;
  street: string;
  postalCode: string;
  city: string;
  country: string;
  email: string;
  phone: string;
}

/**
 * Rechnungsanschrift von ABSINA (index.html:4065-4074). Sie wird beim Anlegen und beim Nachziehen
 * einer Bestellung als `order.billingAddress` kopiert (index.html:5817-5818, 7854, 8124).
 *
 * `Object.freeze` ist woertlich aus dem Original uebernommen und nicht bloss Typ-Kosmetik: das
 * Original laeuft im strict mode, ein Schreibversuch wirft dort. Ein blosses `Readonly<...>` waere
 * eine reine Kompilierzeit-Zusicherung und damit eine Verhaltensaenderung.
 */
export const ABSINA_BILLING_ADDRESS: Readonly<BillingAddress> = Object.freeze({
  company: "ABSINA GmbH",
  companyAddition: "Markus Wiese, Kai Schifferdecker",
  street: "Max-Born-Straße 2",
  postalCode: "74722",
  city: "Buchen",
  country: "Deutschland",
  email: "service@absina.de",
  phone: "06281 90286 00",
});
